module.exports = __webpack_public_path__ + "img/samsung-galaxy-note4.b4f20c19.jpg";